import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { applySession, refreshUser } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        const token = searchParams.get("token");
        const callbackError = searchParams.get("error");
        if (callbackError) {
            setError(callbackError);
            return;
        }
        if (!token) {
            setError("No session token was returned.");
            return;
        }
        applySession(token);
        refreshUser().finally(() => navigate("/replay", { replace: true }));
    }, [applySession, navigate, refreshUser, searchParams]);

    return (
        <div className="grid min-h-[calc(100svh-4rem)] place-items-center px-4 pt-24">
            <div className="glass-strong max-w-md rounded-3xl border border-white/10 p-8 text-center">
                {error ? (
                    <>
                        <div className="label-eyebrow text-f1-red">AUTH ERROR</div>
                        <h1 className="mt-4 font-display text-4xl">Could not log you in.</h1>
                        <p className="mt-4 text-sm text-zinc-400">{error}</p>
                        <Link to="/login" className="mt-6 inline-flex rounded-xl bg-f1-red px-5 py-3 text-sm font-semibold text-white">
                            Back to login
                        </Link>
                    </>
                ) : (
                    <>
                        <div className="label-eyebrow text-f1-red">SECURING SESSION</div>
                        <h1 className="mt-4 font-display text-4xl">Opening Outlapped...</h1>
                        <p className="mt-4 text-sm text-zinc-500">Your account session is being prepared.</p>
                    </>
                )}
            </div>
        </div>
    );
}
